import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup} from '@angular/forms';
import {SmsService} from '../../../shared/service/sms.service';
import {SmsModel} from '../../../model/smsModel';
import {ActionMode} from '../../../shared/enums/action-mode.enum';
import swal from 'sweetalert2';
import {Status} from '../../../model/status';

@Component({
  selector: 'app-sms-popup',
  templateUrl: './sms-popup.component.html',
  styleUrls: ['./sms-popup.component.scss']
})
export class SmsPopupComponent implements OnInit {
  @Input() smsMgtCopy_:SmsModel[];
  @Input() statusFromTable: string;
  public smsMgt: any;
  public smsPopup: FormGroup;
  public selectedMode;
  ActionMode = ActionMode;
  public phoneNo:string;
  public message:string;
  public createdTime:Date;
  public status: Status;
  public id:number;

  constructor(public modalService: NgbModal,
              public activeModal: NgbActiveModal,
              private smsService:SmsService) { }

  ngOnInit() {
    this.smsPopup =new FormGroup({
      phoneNo:new FormControl(null),
      message:new FormControl(null),
      createdTime:new FormControl(null),
      status:new FormControl(null)
    });
    console.log("message " + this.status.statusCode);
    this.smsMgt = {...this.smsMgtCopy_};
    if (this.selectedMode === ActionMode.VIEW) {
      this.smsPopup.disable();
    }
  }


  onSubmit() {
    let isValid: boolean = true;
    let errorMessage: string = '';
    if (isValid) {
      swal.fire({
        title: "Are you sure, you want to submit?",
        text: "",
        showCancelButton: true,

        confirmButtonText: "Yes"
      }).then((result)=>{
        if(result.value){
          const smsDTO =new SmsModel(
            this.id,
            this.status
          );
          this.smsService.updateSmsDetails(smsDTO).subscribe(
            (success: string) => {
              swal.fire("Success", "Details submitted successfully", "success");
               // window.location.reload();
            },(error) => {
              console.log(error);
              swal.fire("Sorry!", "Something went wrong...!", "error");
            },() => {
              this.activeModal.close("Saved");
            }
          );
        }
      }, reason => {
        }
      );
    } else{
      swal.fire('Error',errorMessage,'error');
    }
  }



  }



